<ejs-pdfviewer id="HrimPdfViewer"
               [resourceUrl]='pdfResource'
               [serviceUrl]='pdfService'
               [enableFormFields]='enableFormFields'
               [enablePrint]="enablePrint"
               [printMode]="printMode"
               [enableFormDesignerToolbar]=false
               [enableFormFieldsValidation]='true'
               [enableDownload]="enableDownload"
               [isSignatureEditable]=false
               [enableAnnotationToolbar]="allowAnnotationEditTool"
               (documentLoad)="documentLoaded($event)"
               (downloadStart)="documentStartDownload($event)"
               (downloadEnd)="documentEndDownload($event)"
               (printStart)="documentStartPrint($event)"
               (printEnd)="documentEndPrint($event)"
               style="height:640px;display:block">
</ejs-pdfviewer>